'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;



//////////////////
// WEBPACK FOOTER
// ../~/call-bind-apply-helpers/functionApply.js
// module id = 136
// module chunks = 0